module.exports = __webpack_public_path__ + "img/LOGO.44d547f6.png";